import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Box, Flex } from 'reflexbox';
import styled, { useTheme } from 'styled-components';

import { CloseIcon, Logo } from '@treams/treams-icons';
import { IconButton, Skeleton } from '@treams/treams-ui';

import { TOP_BAR_HEIGHT } from './topBarHeight';

const LogoContainer = styled(Box)`
	transition: 0.4s ease-out opacity;
	display: flex;
	align-items: center;
	/* Reserves the taller inline logo's height so swapping it for a workspace
	   image does not shift the row. */
	min-height: 49px;

	svg {
		display: block;
		width: 140px;
		height: 50px;
	}

	img {
		display: block;
		max-width: 140px;
		max-height: 40px;
		object-fit: contain;
		object-position: left center;
	}

	&:hover {
		opacity: 0.5;
	}
`;

export default function NavHeader(props: { onClose?: () => void }) {
	const { t } = useTranslation();
	const theme = useTheme();

	return (
		<Box mb={3}>
			<Flex alignItems="center" height={TOP_BAR_HEIGHT}>
				<Box flexGrow={1} flexShrink={1}>
					{theme.images.logo ? (
						<Link to="/">
							<LogoContainer flexGrow={0} flexShrink={0}>
								{theme.images.logo.startsWith('/') ? (
									<Logo />
								) : (
									<img src={theme.images.logo} alt="Logo" />
								)}
							</LogoContainer>
						</Link>
					) : (
						<Skeleton.Box width={140} height={50} />
					)}
				</Box>
				{props.onClose && (
					<IconButton
						type="secondary"
						icon={<CloseIcon />}
						aria-label={t('sidebar.close')}
						onClick={props.onClose}
					/>
				)}
			</Flex>
		</Box>
	);
}
